/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface TagsService {
  /**
   * @summary Get All
   * @description Get all tags for the office.
   */
  getAllTagsGet: {
    /**
     * @summary Get All
     * @description Get all tags for the office.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetAllTagsGetSchema, GetAllTagsGetParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<GetAllTagsGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: GetAllTagsGetSchema,
        options: {
          parameters: GetAllTagsGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetAllTagsGetData, GetAllTagsGetError>>
    ): Promise<RequestFnResponse<GetAllTagsGetData, GetAllTagsGetError>>;
    /**
     * @summary Get All
     * @description Get all tags for the office.
     */
    getQueryKey(
      parameters: DeepReadonly<GetAllTagsGetParameters> | void
    ): ServiceOperationQueryKey<GetAllTagsGetSchema, GetAllTagsGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @description Get all tags for the office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.tagsService.getAllTagsGet.useQuery()
     * ```
     */
    useQuery<TData = GetAllTagsGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllTagsGetSchema, GetAllTagsGetParameters>
        | (DeepReadonly<GetAllTagsGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          GetAllTagsGetData,
          GetAllTagsGetError,
          TData,
          ServiceOperationQueryKey<GetAllTagsGetSchema, GetAllTagsGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetAllTagsGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @description Get all tags for the office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.tagsService.getAllTagsGet.useQuery()
     * ```
     */
    useQuery<TData = GetAllTagsGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllTagsGetSchema, GetAllTagsGetParameters>
        | (DeepReadonly<GetAllTagsGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          GetAllTagsGetData,
          GetAllTagsGetError,
          TData,
          ServiceOperationQueryKey<GetAllTagsGetSchema, GetAllTagsGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetAllTagsGetError>>;
    /**
     * @summary Get All
     * @description Get all tags for the office.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetAllTagsGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<GetAllTagsGetSchema, GetAllTagsGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @description Get all tags for the office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.tagsService.getAllTagsGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllTagsGetParameters,
      TQueryFnData = GetAllTagsGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllTagsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllTagsGetSchema, GetAllTagsGetParameters>
        | (DeepReadonly<GetAllTagsGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllTagsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetAllTagsGetSchema, GetAllTagsGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetAllTagsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @description Get all tags for the office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.tagsService.getAllTagsGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllTagsGetParameters,
      TQueryFnData = GetAllTagsGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllTagsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllTagsGetSchema, GetAllTagsGetParameters>
        | (DeepReadonly<GetAllTagsGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllTagsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetAllTagsGetSchema, GetAllTagsGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAllTagsGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetAllTagsGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get All
     * @description Get all tags for the office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getAllTagsGetTotal = qraft.tagsService.getAllTagsGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllTagsGetSchema,
            GetAllTagsGetData,
            TInfinite,
            GetAllTagsGetParameters,
            GetAllTagsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllTagsGetSchema,
            GetAllTagsGetData,
            TInfinite,
            GetAllTagsGetParameters,
            GetAllTagsGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get All
     * @description Get all tags for the office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getAllTagsGetResults = qraft.tagsService.getAllTagsGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllTagsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getAllTagsGetCombinedResults = qraft.tagsService.getAllTagsGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllTagsGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetAllTagsGetSchema,
          GetAllTagsGetParameters,
          GetAllTagsGetData,
          GetAllTagsGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetAllTagsGetData, GetAllTagsGetError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<GetAllTagsGetData, GetAllTagsGetError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @description Get all tags for the office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.tagsService.getAllTagsGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = GetAllTagsGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllTagsGetSchema, GetAllTagsGetParameters>
        | (DeepReadonly<GetAllTagsGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          GetAllTagsGetData,
          GetAllTagsGetError,
          TData,
          ServiceOperationQueryKey<GetAllTagsGetSchema, GetAllTagsGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetAllTagsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get All
     * @description Get all tags for the office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.tagsService.getAllTagsGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends GetAllTagsGetParameters, TData = GetAllTagsGetData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllTagsGetSchema, GetAllTagsGetParameters>
        | (DeepReadonly<GetAllTagsGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetAllTagsGetData,
          GetAllTagsGetError,
          OperationInfiniteData<TData, GetAllTagsGetParameters>,
          ServiceOperationInfiniteQueryKey<GetAllTagsGetSchema, GetAllTagsGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAllTagsGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetAllTagsGetParameters>,
      OperationError<GetAllTagsGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @description Get all tags for the office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getAllTagsGetData = qraft.tagsService.getAllTagsGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllTagsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getAllTagsGetCombinedData = qraft.tagsService.getAllTagsGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllTagsGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetAllTagsGetSchema,
          GetAllTagsGetParameters,
          GetAllTagsGetData,
          GetAllTagsGetError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetAllTagsGetData, GetAllTagsGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<GetAllTagsGetData, GetAllTagsGetError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get All
     * @description Get all tags for the office.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllTagsGetSchema,
        GetAllTagsGetData,
        GetAllTagsGetParameters,
        GetAllTagsGetError
      > | void
    ): Promise<GetAllTagsGetData>;
    /**
     * @summary Get All
     * @description Get all tags for the office.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllTagsGetSchema,
        GetAllTagsGetData,
        GetAllTagsGetParameters,
        GetAllTagsGetError
      > | void
    ): Promise<void>;
    /**
     * @summary Get All
     * @description Get all tags for the office.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetAllTagsGetSchema,
        GetAllTagsGetData,
        GetAllTagsGetParameters,
        GetAllTagsGetError
      > | void
    ): Promise<GetAllTagsGetData>;
    /**
     * @summary Get All
     * @description Get all tags for the office.
     */
    fetchInfiniteQuery<TPageParam extends GetAllTagsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllTagsGetSchema,
        GetAllTagsGetData,
        GetAllTagsGetParameters,
        DeepReadonly<TPageParam>,
        GetAllTagsGetError
      > | void
    ): Promise<OperationInfiniteData<GetAllTagsGetData, GetAllTagsGetParameters>>;
    /**
     * @summary Get All
     * @description Get all tags for the office.
     */
    prefetchInfiniteQuery<TPageParam extends GetAllTagsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllTagsGetSchema,
        GetAllTagsGetData,
        GetAllTagsGetParameters,
        DeepReadonly<TPageParam>,
        GetAllTagsGetError
      > | void
    ): Promise<void>;
    /**
     * @summary Get All
     * @description Get all tags for the office.
     */
    ensureInfiniteQueryData<TPageParam extends GetAllTagsGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetAllTagsGetSchema,
        GetAllTagsGetData,
        GetAllTagsGetParameters,
        DeepReadonly<TPageParam>,
        GetAllTagsGetError
      > | void
    ): Promise<OperationInfiniteData<GetAllTagsGetData, GetAllTagsGetParameters>>;
    /**
     * @summary Get All
     * @description Get all tags for the office.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetAllTagsGetSchema, GetAllTagsGetParameters>
        | (DeepReadonly<GetAllTagsGetParameters> | void)
    ): GetAllTagsGetData | undefined;
    /**
     * @summary Get All
     * @description Get all tags for the office.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllTagsGetSchema, GetAllTagsGetParameters>
        | (DeepReadonly<GetAllTagsGetParameters> | void)
    ): OperationInfiniteData<GetAllTagsGetData, GetAllTagsGetParameters> | undefined;
    /**
     * @summary Get All
     * @description Get all tags for the office.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllTagsGetSchema,
            GetAllTagsGetData,
            TInfinite,
            GetAllTagsGetParameters,
            GetAllTagsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllTagsGetSchema,
            GetAllTagsGetData,
            TInfinite,
            GetAllTagsGetParameters,
            GetAllTagsGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<GetAllTagsGetSchema, GetAllTagsGetParameters>,
            data: NoInfer<OperationInfiniteData<GetAllTagsGetData, GetAllTagsGetParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetAllTagsGetSchema, GetAllTagsGetParameters>,
            data: GetAllTagsGetData | undefined,
          ]
        >;
    /**
     * @summary Get All
     * @description Get all tags for the office.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetAllTagsGetSchema, GetAllTagsGetParameters>
        | (DeepReadonly<GetAllTagsGetParameters> | void)
    ): QueryState<GetAllTagsGetData, GetAllTagsGetError> | undefined;
    /**
     * @summary Get All
     * @description Get all tags for the office.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetAllTagsGetParameters>
        | ServiceOperationInfiniteQueryKey<GetAllTagsGetSchema, GetAllTagsGetParameters>
        | void
    ): QueryState<OperationInfiniteData<GetAllTagsGetData, GetAllTagsGetParameters>, GetAllTagsGetError> | undefined;
    /**
     * @summary Get All
     * @description Get all tags for the office.
     */
    setQueryData(
      parameters:
        | (DeepReadonly<GetAllTagsGetParameters> | undefined)
        | ServiceOperationQueryKey<GetAllTagsGetSchema, GetAllTagsGetParameters>,
      updater: Updater<NoInfer<GetAllTagsGetData> | undefined, NoInfer<DeepReadonly<GetAllTagsGetData>> | undefined>,
      options?: SetDataOptions
    ): GetAllTagsGetData | undefined;
    /**
     * @summary Get All
     * @description Get all tags for the office.
     */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<GetAllTagsGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<GetAllTagsGetSchema, GetAllTagsGetParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetAllTagsGetData, GetAllTagsGetParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<GetAllTagsGetData, GetAllTagsGetParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetAllTagsGetData, GetAllTagsGetParameters> | undefined;
    /**
     * @summary Get All
     * @description Get all tags for the office.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetAllTagsGetSchema,
            GetAllTagsGetData,
            TInfinite,
            GetAllTagsGetParameters,
            GetAllTagsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllTagsGetSchema,
            GetAllTagsGetData,
            TInfinite,
            GetAllTagsGetParameters,
            GetAllTagsGetError
          >,
      updater: Updater<NoInfer<GetAllTagsGetData> | undefined, NoInfer<GetAllTagsGetData> | undefined>,
      options?: SetDataOptions
    ): Array<GetAllTagsGetData | undefined>;
    /**
     * @summary Get All
     * @description Get all tags for the office.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetAllTagsGetSchema,
        GetAllTagsGetData,
        TInfinite,
        GetAllTagsGetParameters,
        GetAllTagsGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get All
     * @description Get all tags for the office.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllTagsGetSchema,
            GetAllTagsGetData,
            TInfinite,
            GetAllTagsGetParameters,
            GetAllTagsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllTagsGetSchema,
            GetAllTagsGetData,
            TInfinite,
            GetAllTagsGetParameters,
            GetAllTagsGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get All
     * @description Get all tags for the office.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllTagsGetSchema,
            GetAllTagsGetData,
            TInfinite,
            GetAllTagsGetParameters,
            GetAllTagsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllTagsGetSchema,
            GetAllTagsGetData,
            TInfinite,
            GetAllTagsGetParameters,
            GetAllTagsGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get All
     * @description Get all tags for the office.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllTagsGetSchema,
            GetAllTagsGetData,
            TInfinite,
            GetAllTagsGetParameters,
            GetAllTagsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllTagsGetSchema,
            GetAllTagsGetData,
            TInfinite,
            GetAllTagsGetParameters,
            GetAllTagsGetError
          >
    ): void;
    /**
     * @summary Get All
     * @description Get all tags for the office.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllTagsGetSchema,
            GetAllTagsGetData,
            TInfinite,
            GetAllTagsGetParameters,
            GetAllTagsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllTagsGetSchema,
            GetAllTagsGetData,
            TInfinite,
            GetAllTagsGetParameters,
            GetAllTagsGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get All
     * @description Get all tags for the office.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllTagsGetSchema,
            GetAllTagsGetData,
            TInfinite,
            GetAllTagsGetParameters,
            GetAllTagsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllTagsGetSchema,
            GetAllTagsGetData,
            TInfinite,
            GetAllTagsGetParameters,
            GetAllTagsGetError
          >
    ): number;
    schema: GetAllTagsGetSchema;
    types: {
      parameters: GetAllTagsGetParameters;
      data: GetAllTagsGetData;
      error: GetAllTagsGetError;
    };
  };
  /**
   * @summary Create
   * @description Create a new tag.
   */
  createTagsPost: {
    /**
     * @summary Create
     * @description Create a new tag.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<CreateTagsPostBody, CreateTagsPostParameters, TMeta, TSignal>,
      client?: (
        schema: CreateTagsPostSchema,
        options: ServiceOperationMutationFnOptions<CreateTagsPostBody, CreateTagsPostParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<CreateTagsPostData, CreateTagsPostError>>
    ): Promise<RequestFnResponse<CreateTagsPostData, CreateTagsPostError>>;
    /**
     * @summary Create
     * @description Create a new tag.
     */
    getMutationKey(
      parameters: DeepReadonly<CreateTagsPostParameters> | void
    ): ServiceOperationMutationKey<CreateTagsPostSchema, CreateTagsPostParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @description Create a new tag.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.tagsService.createTagsPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.tagsService.createTagsPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateTagsPostBody, TContext = unknown>(
      parameters: DeepReadonly<CreateTagsPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateTagsPostSchema,
        CreateTagsPostData,
        CreateTagsPostParameters,
        TVariables,
        OperationError<CreateTagsPostError>,
        TContext
      >
    ): UseMutationResult<CreateTagsPostData, OperationError<CreateTagsPostError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @description Create a new tag.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.tagsService.createTagsPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.tagsService.createTagsPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends MutationVariables<CreateTagsPostBody, CreateTagsPostParameters>, TContext = unknown>(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateTagsPostSchema,
        CreateTagsPostData,
        CreateTagsPostParameters,
        TVariables,
        OperationError<CreateTagsPostError>,
        TContext
      >
    ): UseMutationResult<CreateTagsPostData, OperationError<CreateTagsPostError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create
     * @description Create a new tag.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createTagsPostTotal = qraft.tagsService.createTagsPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createTagsPostTotal = qraft.tagsService.createTagsPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateTagsPostBody,
            CreateTagsPostData,
            CreateTagsPostParameters,
            OperationError<CreateTagsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateTagsPostSchema,
            CreateTagsPostBody,
            CreateTagsPostData,
            CreateTagsPostParameters,
            OperationError<CreateTagsPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create
     * @description Create a new tag.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createTagsPostPendingMutationVariables = qraft.tagsService.createTagsPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createTagsPostMutationData = qraft.tagsService.createTagsPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateTagsPostData,
        OperationError<CreateTagsPostError>,
        MutationVariables<CreateTagsPostBody, CreateTagsPostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateTagsPostBody,
            CreateTagsPostData,
            CreateTagsPostParameters,
            OperationError<CreateTagsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateTagsPostSchema,
            CreateTagsPostBody,
            CreateTagsPostData,
            CreateTagsPostParameters,
            OperationError<CreateTagsPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateTagsPostData,
          OperationError<CreateTagsPostError>,
          MutationVariables<CreateTagsPostBody, CreateTagsPostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Create
     * @description Create a new tag.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateTagsPostBody,
            CreateTagsPostData,
            CreateTagsPostParameters,
            OperationError<CreateTagsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateTagsPostSchema,
            CreateTagsPostBody,
            CreateTagsPostData,
            CreateTagsPostParameters,
            OperationError<CreateTagsPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create
     * @description Create a new tag.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.tagsService.createTagsPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.tagsService.createTagsPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateTagsPostBody,
              CreateTagsPostData,
              CreateTagsPostParameters,
              OperationError<CreateTagsPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateTagsPostSchema,
              CreateTagsPostBody,
              CreateTagsPostData,
              CreateTagsPostParameters,
              OperationError<CreateTagsPostError>,
              TContext
            >
      ):
        | Mutation<
            CreateTagsPostData,
            CreateTagsPostError,
            MutationVariables<CreateTagsPostBody, CreateTagsPostParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateTagsPostBody,
              CreateTagsPostData,
              CreateTagsPostParameters,
              OperationError<CreateTagsPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateTagsPostSchema,
              CreateTagsPostBody,
              CreateTagsPostData,
              CreateTagsPostParameters,
              OperationError<CreateTagsPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateTagsPostData,
          CreateTagsPostError,
          MutationVariables<CreateTagsPostBody, CreateTagsPostParameters>,
          TContext
        >
      >;
    };
    schema: CreateTagsPostSchema;
    types: {
      parameters: CreateTagsPostParameters;
      data: CreateTagsPostData;
      error: CreateTagsPostError;
      body: CreateTagsPostBody;
    };
  };
  /**
   * @summary Get One
   * @description Get a specific tag by ID.
   */
  getOneTagsTagIdGet: {
    /**
     * @summary Get One
     * @description Get a specific tag by ID.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetOneTagsTagIdGetSchema, GetOneTagsTagIdGetParameters, TMeta, TSignal>
        | QueryFnOptionsByParameters<GetOneTagsTagIdGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetOneTagsTagIdGetSchema,
        options: {
          parameters: GetOneTagsTagIdGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetOneTagsTagIdGetData, GetOneTagsTagIdGetError>>
    ): Promise<RequestFnResponse<GetOneTagsTagIdGetData, GetOneTagsTagIdGetError>>;
    /**
     * @summary Get One
     * @description Get a specific tag by ID.
     */
    getQueryKey(
      parameters: DeepReadonly<GetOneTagsTagIdGetParameters>
    ): ServiceOperationQueryKey<GetOneTagsTagIdGetSchema, GetOneTagsTagIdGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get One
     * @description Get a specific tag by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.tagsService.getOneTagsTagIdGet.useQuery({
     *     path: {
     *         tag_id: tagId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetOneTagsTagIdGetData>(
      parameters:
        | ServiceOperationQueryKey<GetOneTagsTagIdGetSchema, GetOneTagsTagIdGetParameters>
        | DeepReadonly<GetOneTagsTagIdGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetOneTagsTagIdGetData,
          GetOneTagsTagIdGetError,
          TData,
          ServiceOperationQueryKey<GetOneTagsTagIdGetSchema, GetOneTagsTagIdGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetOneTagsTagIdGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get One
     * @description Get a specific tag by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.tagsService.getOneTagsTagIdGet.useQuery({
     *     path: {
     *         tag_id: tagId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetOneTagsTagIdGetData>(
      parameters:
        | ServiceOperationQueryKey<GetOneTagsTagIdGetSchema, GetOneTagsTagIdGetParameters>
        | DeepReadonly<GetOneTagsTagIdGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetOneTagsTagIdGetData,
          GetOneTagsTagIdGetError,
          TData,
          ServiceOperationQueryKey<GetOneTagsTagIdGetSchema, GetOneTagsTagIdGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetOneTagsTagIdGetError>>;
    /**
     * @summary Get One
     * @description Get a specific tag by ID.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetOneTagsTagIdGetParameters>
    ): ServiceOperationInfiniteQueryKey<GetOneTagsTagIdGetSchema, GetOneTagsTagIdGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get One
     * @description Get a specific tag by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.tagsService.getOneTagsTagIdGet.useInfiniteQuery({
     *     path: {
     *         tag_id: tagId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetOneTagsTagIdGetParameters,
      TQueryFnData = GetOneTagsTagIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetOneTagsTagIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetOneTagsTagIdGetSchema, GetOneTagsTagIdGetParameters>
        | DeepReadonly<GetOneTagsTagIdGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetOneTagsTagIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetOneTagsTagIdGetSchema, GetOneTagsTagIdGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetOneTagsTagIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get One
     * @description Get a specific tag by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.tagsService.getOneTagsTagIdGet.useInfiniteQuery({
     *     path: {
     *         tag_id: tagId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetOneTagsTagIdGetParameters,
      TQueryFnData = GetOneTagsTagIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetOneTagsTagIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetOneTagsTagIdGetSchema, GetOneTagsTagIdGetParameters>
        | DeepReadonly<GetOneTagsTagIdGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetOneTagsTagIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetOneTagsTagIdGetSchema, GetOneTagsTagIdGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetOneTagsTagIdGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetOneTagsTagIdGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get One
     * @description Get a specific tag by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getOneTagsTagIdGetTotal = qraft.tagsService.getOneTagsTagIdGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getOneTagsTagIdGetByParametersTotal = qraft.tagsService.getOneTagsTagIdGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             tag_id: tagId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetOneTagsTagIdGetSchema,
            GetOneTagsTagIdGetData,
            TInfinite,
            GetOneTagsTagIdGetParameters,
            GetOneTagsTagIdGetError
          >
        | QueryFiltersByQueryKey<
            GetOneTagsTagIdGetSchema,
            GetOneTagsTagIdGetData,
            TInfinite,
            GetOneTagsTagIdGetParameters,
            GetOneTagsTagIdGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get One
     * @description Get a specific tag by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getOneTagsTagIdGetResults = qraft.tagsService.getOneTagsTagIdGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 tag_id: tagId1
     *             }
     *         },
     *         {
     *             path: {
     *                 tag_id: tagId2
     *             }
     *         }
     *     ]
     * });
     * getOneTagsTagIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getOneTagsTagIdGetCombinedResults = qraft.tagsService.getOneTagsTagIdGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 tag_id: tagId1
     *             }
     *         },
     *         {
     *             path: {
     *                 tag_id: tagId2
     *             }
     *         }
     *     ]
     * });
     * getOneTagsTagIdGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetOneTagsTagIdGetSchema,
          GetOneTagsTagIdGetParameters,
          GetOneTagsTagIdGetData,
          GetOneTagsTagIdGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetOneTagsTagIdGetData, GetOneTagsTagIdGetError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<GetOneTagsTagIdGetData, GetOneTagsTagIdGetError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get One
     * @description Get a specific tag by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.tagsService.getOneTagsTagIdGet.useSuspenseQuery({
     *     path: {
     *         tag_id: tagId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetOneTagsTagIdGetData>(
      parameters:
        | ServiceOperationQueryKey<GetOneTagsTagIdGetSchema, GetOneTagsTagIdGetParameters>
        | DeepReadonly<GetOneTagsTagIdGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetOneTagsTagIdGetData,
          GetOneTagsTagIdGetError,
          TData,
          ServiceOperationQueryKey<GetOneTagsTagIdGetSchema, GetOneTagsTagIdGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetOneTagsTagIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get One
     * @description Get a specific tag by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.tagsService.getOneTagsTagIdGet.useSuspenseInfiniteQuery({
     *     path: {
     *         tag_id: tagId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends GetOneTagsTagIdGetParameters, TData = GetOneTagsTagIdGetData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetOneTagsTagIdGetSchema, GetOneTagsTagIdGetParameters>
        | DeepReadonly<GetOneTagsTagIdGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetOneTagsTagIdGetData,
          GetOneTagsTagIdGetError,
          OperationInfiniteData<TData, GetOneTagsTagIdGetParameters>,
          ServiceOperationInfiniteQueryKey<GetOneTagsTagIdGetSchema, GetOneTagsTagIdGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetOneTagsTagIdGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetOneTagsTagIdGetParameters>,
      OperationError<GetOneTagsTagIdGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get One
     * @description Get a specific tag by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getOneTagsTagIdGetData = qraft.tagsService.getOneTagsTagIdGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 tag_id: tagId1
     *             }
     *         },
     *         {
     *             path: {
     *                 tag_id: tagId2
     *             }
     *         }
     *     ]
     * });
     * getOneTagsTagIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getOneTagsTagIdGetCombinedData = qraft.tagsService.getOneTagsTagIdGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 tag_id: tagId1
     *             }
     *         },
     *         {
     *             path: {
     *                 tag_id: tagId2
     *             }
     *         }
     *     ]
     * });
     * getOneTagsTagIdGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetOneTagsTagIdGetSchema,
          GetOneTagsTagIdGetParameters,
          GetOneTagsTagIdGetData,
          GetOneTagsTagIdGetError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetOneTagsTagIdGetData, GetOneTagsTagIdGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<GetOneTagsTagIdGetData, GetOneTagsTagIdGetError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get One
     * @description Get a specific tag by ID.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetOneTagsTagIdGetSchema,
        GetOneTagsTagIdGetData,
        GetOneTagsTagIdGetParameters,
        GetOneTagsTagIdGetError
      >
    ): Promise<GetOneTagsTagIdGetData>;
    /**
     * @summary Get One
     * @description Get a specific tag by ID.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetOneTagsTagIdGetSchema,
        GetOneTagsTagIdGetData,
        GetOneTagsTagIdGetParameters,
        GetOneTagsTagIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Get One
     * @description Get a specific tag by ID.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetOneTagsTagIdGetSchema,
        GetOneTagsTagIdGetData,
        GetOneTagsTagIdGetParameters,
        GetOneTagsTagIdGetError
      >
    ): Promise<GetOneTagsTagIdGetData>;
    /**
     * @summary Get One
     * @description Get a specific tag by ID.
     */
    fetchInfiniteQuery<TPageParam extends GetOneTagsTagIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetOneTagsTagIdGetSchema,
        GetOneTagsTagIdGetData,
        GetOneTagsTagIdGetParameters,
        DeepReadonly<TPageParam>,
        GetOneTagsTagIdGetError
      >
    ): Promise<OperationInfiniteData<GetOneTagsTagIdGetData, GetOneTagsTagIdGetParameters>>;
    /**
     * @summary Get One
     * @description Get a specific tag by ID.
     */
    prefetchInfiniteQuery<TPageParam extends GetOneTagsTagIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetOneTagsTagIdGetSchema,
        GetOneTagsTagIdGetData,
        GetOneTagsTagIdGetParameters,
        DeepReadonly<TPageParam>,
        GetOneTagsTagIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Get One
     * @description Get a specific tag by ID.
     */
    ensureInfiniteQueryData<TPageParam extends GetOneTagsTagIdGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetOneTagsTagIdGetSchema,
        GetOneTagsTagIdGetData,
        GetOneTagsTagIdGetParameters,
        DeepReadonly<TPageParam>,
        GetOneTagsTagIdGetError
      >
    ): Promise<OperationInfiniteData<GetOneTagsTagIdGetData, GetOneTagsTagIdGetParameters>>;
    /**
     * @summary Get One
     * @description Get a specific tag by ID.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetOneTagsTagIdGetSchema, GetOneTagsTagIdGetParameters>
        | DeepReadonly<GetOneTagsTagIdGetParameters>
    ): GetOneTagsTagIdGetData | undefined;
    /**
     * @summary Get One
     * @description Get a specific tag by ID.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetOneTagsTagIdGetSchema, GetOneTagsTagIdGetParameters>
        | DeepReadonly<GetOneTagsTagIdGetParameters>
    ): OperationInfiniteData<GetOneTagsTagIdGetData, GetOneTagsTagIdGetParameters> | undefined;
    /**
     * @summary Get One
     * @description Get a specific tag by ID.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetOneTagsTagIdGetSchema,
            GetOneTagsTagIdGetData,
            TInfinite,
            GetOneTagsTagIdGetParameters,
            GetOneTagsTagIdGetError
          >
        | QueryFiltersByQueryKey<
            GetOneTagsTagIdGetSchema,
            GetOneTagsTagIdGetData,
            TInfinite,
            GetOneTagsTagIdGetParameters,
            GetOneTagsTagIdGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<GetOneTagsTagIdGetSchema, GetOneTagsTagIdGetParameters>,
            data: NoInfer<OperationInfiniteData<GetOneTagsTagIdGetData, GetOneTagsTagIdGetParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetOneTagsTagIdGetSchema, GetOneTagsTagIdGetParameters>,
            data: GetOneTagsTagIdGetData | undefined,
          ]
        >;
    /**
     * @summary Get One
     * @description Get a specific tag by ID.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetOneTagsTagIdGetSchema, GetOneTagsTagIdGetParameters>
        | DeepReadonly<GetOneTagsTagIdGetParameters>
    ): QueryState<GetOneTagsTagIdGetData, GetOneTagsTagIdGetError> | undefined;
    /**
     * @summary Get One
     * @description Get a specific tag by ID.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetOneTagsTagIdGetParameters>
        | ServiceOperationInfiniteQueryKey<GetOneTagsTagIdGetSchema, GetOneTagsTagIdGetParameters>
    ):
      | QueryState<OperationInfiniteData<GetOneTagsTagIdGetData, GetOneTagsTagIdGetParameters>, GetOneTagsTagIdGetError>
      | undefined;
    /**
     * @summary Get One
     * @description Get a specific tag by ID.
     */
    setQueryData(
      parameters:
        | DeepReadonly<GetOneTagsTagIdGetParameters>
        | ServiceOperationQueryKey<GetOneTagsTagIdGetSchema, GetOneTagsTagIdGetParameters>,
      updater: Updater<
        NoInfer<GetOneTagsTagIdGetData> | undefined,
        NoInfer<DeepReadonly<GetOneTagsTagIdGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetOneTagsTagIdGetData | undefined;
    /**
     * @summary Get One
     * @description Get a specific tag by ID.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetOneTagsTagIdGetParameters>
        | ServiceOperationInfiniteQueryKey<GetOneTagsTagIdGetSchema, GetOneTagsTagIdGetParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetOneTagsTagIdGetData, GetOneTagsTagIdGetParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<GetOneTagsTagIdGetData, GetOneTagsTagIdGetParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetOneTagsTagIdGetData, GetOneTagsTagIdGetParameters> | undefined;
    /**
     * @summary Get One
     * @description Get a specific tag by ID.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetOneTagsTagIdGetSchema,
            GetOneTagsTagIdGetData,
            TInfinite,
            GetOneTagsTagIdGetParameters,
            GetOneTagsTagIdGetError
          >
        | QueryFiltersByQueryKey<
            GetOneTagsTagIdGetSchema,
            GetOneTagsTagIdGetData,
            TInfinite,
            GetOneTagsTagIdGetParameters,
            GetOneTagsTagIdGetError
          >,
      updater: Updater<NoInfer<GetOneTagsTagIdGetData> | undefined, NoInfer<GetOneTagsTagIdGetData> | undefined>,
      options?: SetDataOptions
    ): Array<GetOneTagsTagIdGetData | undefined>;
    /**
     * @summary Get One
     * @description Get a specific tag by ID.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetOneTagsTagIdGetSchema,
        GetOneTagsTagIdGetData,
        TInfinite,
        GetOneTagsTagIdGetParameters,
        GetOneTagsTagIdGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get One
     * @description Get a specific tag by ID.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetOneTagsTagIdGetSchema,
            GetOneTagsTagIdGetData,
            TInfinite,
            GetOneTagsTagIdGetParameters,
            GetOneTagsTagIdGetError
          >
        | QueryFiltersByQueryKey<
            GetOneTagsTagIdGetSchema,
            GetOneTagsTagIdGetData,
            TInfinite,
            GetOneTagsTagIdGetParameters,
            GetOneTagsTagIdGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get One
     * @description Get a specific tag by ID.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetOneTagsTagIdGetSchema,
            GetOneTagsTagIdGetData,
            TInfinite,
            GetOneTagsTagIdGetParameters,
            GetOneTagsTagIdGetError
          >
        | QueryFiltersByQueryKey<
            GetOneTagsTagIdGetSchema,
            GetOneTagsTagIdGetData,
            TInfinite,
            GetOneTagsTagIdGetParameters,
            GetOneTagsTagIdGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get One
     * @description Get a specific tag by ID.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetOneTagsTagIdGetSchema,
            GetOneTagsTagIdGetData,
            TInfinite,
            GetOneTagsTagIdGetParameters,
            GetOneTagsTagIdGetError
          >
        | QueryFiltersByQueryKey<
            GetOneTagsTagIdGetSchema,
            GetOneTagsTagIdGetData,
            TInfinite,
            GetOneTagsTagIdGetParameters,
            GetOneTagsTagIdGetError
          >
    ): void;
    /**
     * @summary Get One
     * @description Get a specific tag by ID.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetOneTagsTagIdGetSchema,
            GetOneTagsTagIdGetData,
            TInfinite,
            GetOneTagsTagIdGetParameters,
            GetOneTagsTagIdGetError
          >
        | QueryFiltersByQueryKey<
            GetOneTagsTagIdGetSchema,
            GetOneTagsTagIdGetData,
            TInfinite,
            GetOneTagsTagIdGetParameters,
            GetOneTagsTagIdGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get One
     * @description Get a specific tag by ID.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetOneTagsTagIdGetSchema,
            GetOneTagsTagIdGetData,
            TInfinite,
            GetOneTagsTagIdGetParameters,
            GetOneTagsTagIdGetError
          >
        | QueryFiltersByQueryKey<
            GetOneTagsTagIdGetSchema,
            GetOneTagsTagIdGetData,
            TInfinite,
            GetOneTagsTagIdGetParameters,
            GetOneTagsTagIdGetError
          >
    ): number;
    schema: GetOneTagsTagIdGetSchema;
    types: {
      parameters: GetOneTagsTagIdGetParameters;
      data: GetOneTagsTagIdGetData;
      error: GetOneTagsTagIdGetError;
    };
  };
  /**
   * @summary Update
   * @description Update an existing tag.
   */
  updateTagsTagIdPatch: {
    /**
     * @summary Update
     * @description Update an existing tag.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        UpdateTagsTagIdPatchBody,
        UpdateTagsTagIdPatchParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: UpdateTagsTagIdPatchSchema,
        options: ServiceOperationMutationFnOptions<
          UpdateTagsTagIdPatchBody,
          UpdateTagsTagIdPatchParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<UpdateTagsTagIdPatchData, UpdateTagsTagIdPatchError>>
    ): Promise<RequestFnResponse<UpdateTagsTagIdPatchData, UpdateTagsTagIdPatchError>>;
    /**
     * @summary Update
     * @description Update an existing tag.
     */
    getMutationKey(
      parameters: DeepReadonly<UpdateTagsTagIdPatchParameters> | void
    ): ServiceOperationMutationKey<UpdateTagsTagIdPatchSchema, UpdateTagsTagIdPatchParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @description Update an existing tag.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.tagsService.updateTagsTagIdPatch.useMutation({
     *     path: {
     *         tag_id: tagId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.tagsService.updateTagsTagIdPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         tag_id: tagId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateTagsTagIdPatchBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateTagsTagIdPatchParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateTagsTagIdPatchSchema,
        UpdateTagsTagIdPatchData,
        UpdateTagsTagIdPatchParameters,
        TVariables,
        OperationError<UpdateTagsTagIdPatchError>,
        TContext
      >
    ): UseMutationResult<UpdateTagsTagIdPatchData, OperationError<UpdateTagsTagIdPatchError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @description Update an existing tag.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.tagsService.updateTagsTagIdPatch.useMutation({
     *     path: {
     *         tag_id: tagId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.tagsService.updateTagsTagIdPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         tag_id: tagId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<UpdateTagsTagIdPatchBody, UpdateTagsTagIdPatchParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateTagsTagIdPatchSchema,
        UpdateTagsTagIdPatchData,
        UpdateTagsTagIdPatchParameters,
        TVariables,
        OperationError<UpdateTagsTagIdPatchError>,
        TContext
      >
    ): UseMutationResult<UpdateTagsTagIdPatchData, OperationError<UpdateTagsTagIdPatchError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update
     * @description Update an existing tag.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateTagsTagIdPatchTotal = qraft.tagsService.updateTagsTagIdPatch.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateTagsTagIdPatchTotal = qraft.tagsService.updateTagsTagIdPatch.useIsMutating({
     *     parameters: {
     *         path: {
     *             tag_id: tagId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateTagsTagIdPatchBody,
            UpdateTagsTagIdPatchData,
            UpdateTagsTagIdPatchParameters,
            OperationError<UpdateTagsTagIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateTagsTagIdPatchSchema,
            UpdateTagsTagIdPatchBody,
            UpdateTagsTagIdPatchData,
            UpdateTagsTagIdPatchParameters,
            OperationError<UpdateTagsTagIdPatchError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update
     * @description Update an existing tag.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateTagsTagIdPatchPendingMutationVariables = qraft.tagsService.updateTagsTagIdPatch.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateTagsTagIdPatchMutationData = qraft.tagsService.updateTagsTagIdPatch.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 tag_id: tagId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateTagsTagIdPatchData,
        OperationError<UpdateTagsTagIdPatchError>,
        MutationVariables<UpdateTagsTagIdPatchBody, UpdateTagsTagIdPatchParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateTagsTagIdPatchBody,
            UpdateTagsTagIdPatchData,
            UpdateTagsTagIdPatchParameters,
            OperationError<UpdateTagsTagIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateTagsTagIdPatchSchema,
            UpdateTagsTagIdPatchBody,
            UpdateTagsTagIdPatchData,
            UpdateTagsTagIdPatchParameters,
            OperationError<UpdateTagsTagIdPatchError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateTagsTagIdPatchData,
          OperationError<UpdateTagsTagIdPatchError>,
          MutationVariables<UpdateTagsTagIdPatchBody, UpdateTagsTagIdPatchParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Update
     * @description Update an existing tag.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateTagsTagIdPatchBody,
            UpdateTagsTagIdPatchData,
            UpdateTagsTagIdPatchParameters,
            OperationError<UpdateTagsTagIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateTagsTagIdPatchSchema,
            UpdateTagsTagIdPatchBody,
            UpdateTagsTagIdPatchData,
            UpdateTagsTagIdPatchParameters,
            OperationError<UpdateTagsTagIdPatchError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update
     * @description Update an existing tag.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.tagsService.updateTagsTagIdPatch.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             tag_id: tagId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.tagsService.updateTagsTagIdPatch.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateTagsTagIdPatchBody,
              UpdateTagsTagIdPatchData,
              UpdateTagsTagIdPatchParameters,
              OperationError<UpdateTagsTagIdPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateTagsTagIdPatchSchema,
              UpdateTagsTagIdPatchBody,
              UpdateTagsTagIdPatchData,
              UpdateTagsTagIdPatchParameters,
              OperationError<UpdateTagsTagIdPatchError>,
              TContext
            >
      ):
        | Mutation<
            UpdateTagsTagIdPatchData,
            UpdateTagsTagIdPatchError,
            MutationVariables<UpdateTagsTagIdPatchBody, UpdateTagsTagIdPatchParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateTagsTagIdPatchBody,
              UpdateTagsTagIdPatchData,
              UpdateTagsTagIdPatchParameters,
              OperationError<UpdateTagsTagIdPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateTagsTagIdPatchSchema,
              UpdateTagsTagIdPatchBody,
              UpdateTagsTagIdPatchData,
              UpdateTagsTagIdPatchParameters,
              OperationError<UpdateTagsTagIdPatchError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateTagsTagIdPatchData,
          UpdateTagsTagIdPatchError,
          MutationVariables<UpdateTagsTagIdPatchBody, UpdateTagsTagIdPatchParameters>,
          TContext
        >
      >;
    };
    schema: UpdateTagsTagIdPatchSchema;
    types: {
      parameters: UpdateTagsTagIdPatchParameters;
      data: UpdateTagsTagIdPatchData;
      error: UpdateTagsTagIdPatchError;
      body: UpdateTagsTagIdPatchBody;
    };
  };
  /**
   * @summary Get Tag Links
   * @description Get all links for a specific tag.
   */
  getTagLinksTagsTagIdLinksGet: {
    /**
     * @summary Get Tag Links
     * @description Get all links for a specific tag.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetTagLinksTagsTagIdLinksGetSchema,
            GetTagLinksTagsTagIdLinksGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<GetTagLinksTagsTagIdLinksGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetTagLinksTagsTagIdLinksGetSchema,
        options: {
          parameters: GetTagLinksTagsTagIdLinksGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetTagLinksTagsTagIdLinksGetData, GetTagLinksTagsTagIdLinksGetError>>
    ): Promise<RequestFnResponse<GetTagLinksTagsTagIdLinksGetData, GetTagLinksTagsTagIdLinksGetError>>;
    /**
     * @summary Get Tag Links
     * @description Get all links for a specific tag.
     */
    getQueryKey(
      parameters: DeepReadonly<GetTagLinksTagsTagIdLinksGetParameters>
    ): ServiceOperationQueryKey<GetTagLinksTagsTagIdLinksGetSchema, GetTagLinksTagsTagIdLinksGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Tag Links
     * @description Get all links for a specific tag.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.tagsService.getTagLinksTagsTagIdLinksGet.useQuery({
     *     path: {
     *         tag_id: tagId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetTagLinksTagsTagIdLinksGetData>(
      parameters:
        | ServiceOperationQueryKey<GetTagLinksTagsTagIdLinksGetSchema, GetTagLinksTagsTagIdLinksGetParameters>
        | DeepReadonly<GetTagLinksTagsTagIdLinksGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetTagLinksTagsTagIdLinksGetData,
          GetTagLinksTagsTagIdLinksGetError,
          TData,
          ServiceOperationQueryKey<GetTagLinksTagsTagIdLinksGetSchema, GetTagLinksTagsTagIdLinksGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetTagLinksTagsTagIdLinksGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Tag Links
     * @description Get all links for a specific tag.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.tagsService.getTagLinksTagsTagIdLinksGet.useQuery({
     *     path: {
     *         tag_id: tagId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetTagLinksTagsTagIdLinksGetData>(
      parameters:
        | ServiceOperationQueryKey<GetTagLinksTagsTagIdLinksGetSchema, GetTagLinksTagsTagIdLinksGetParameters>
        | DeepReadonly<GetTagLinksTagsTagIdLinksGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetTagLinksTagsTagIdLinksGetData,
          GetTagLinksTagsTagIdLinksGetError,
          TData,
          ServiceOperationQueryKey<GetTagLinksTagsTagIdLinksGetSchema, GetTagLinksTagsTagIdLinksGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetTagLinksTagsTagIdLinksGetError>>;
    /**
     * @summary Get Tag Links
     * @description Get all links for a specific tag.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetTagLinksTagsTagIdLinksGetParameters>
    ): ServiceOperationInfiniteQueryKey<GetTagLinksTagsTagIdLinksGetSchema, GetTagLinksTagsTagIdLinksGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Tag Links
     * @description Get all links for a specific tag.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.tagsService.getTagLinksTagsTagIdLinksGet.useInfiniteQuery({
     *     path: {
     *         tag_id: tagId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetTagLinksTagsTagIdLinksGetParameters,
      TQueryFnData = GetTagLinksTagsTagIdLinksGetData,
      TData = OperationInfiniteData<TQueryFnData, GetTagLinksTagsTagIdLinksGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetTagLinksTagsTagIdLinksGetSchema, GetTagLinksTagsTagIdLinksGetParameters>
        | DeepReadonly<GetTagLinksTagsTagIdLinksGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetTagLinksTagsTagIdLinksGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetTagLinksTagsTagIdLinksGetSchema, GetTagLinksTagsTagIdLinksGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetTagLinksTagsTagIdLinksGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Tag Links
     * @description Get all links for a specific tag.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.tagsService.getTagLinksTagsTagIdLinksGet.useInfiniteQuery({
     *     path: {
     *         tag_id: tagId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetTagLinksTagsTagIdLinksGetParameters,
      TQueryFnData = GetTagLinksTagsTagIdLinksGetData,
      TData = OperationInfiniteData<TQueryFnData, GetTagLinksTagsTagIdLinksGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetTagLinksTagsTagIdLinksGetSchema, GetTagLinksTagsTagIdLinksGetParameters>
        | DeepReadonly<GetTagLinksTagsTagIdLinksGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetTagLinksTagsTagIdLinksGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetTagLinksTagsTagIdLinksGetSchema, GetTagLinksTagsTagIdLinksGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetTagLinksTagsTagIdLinksGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetTagLinksTagsTagIdLinksGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Tag Links
     * @description Get all links for a specific tag.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getTagLinksTagsTagIdLinksGetTotal = qraft.tagsService.getTagLinksTagsTagIdLinksGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getTagLinksTagsTagIdLinksGetByParametersTotal = qraft.tagsService.getTagLinksTagsTagIdLinksGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             tag_id: tagId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTagLinksTagsTagIdLinksGetSchema,
            GetTagLinksTagsTagIdLinksGetData,
            TInfinite,
            GetTagLinksTagsTagIdLinksGetParameters,
            GetTagLinksTagsTagIdLinksGetError
          >
        | QueryFiltersByQueryKey<
            GetTagLinksTagsTagIdLinksGetSchema,
            GetTagLinksTagsTagIdLinksGetData,
            TInfinite,
            GetTagLinksTagsTagIdLinksGetParameters,
            GetTagLinksTagsTagIdLinksGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Tag Links
     * @description Get all links for a specific tag.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getTagLinksTagsTagIdLinksGetResults = qraft.tagsService.getTagLinksTagsTagIdLinksGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 tag_id: tagId1
     *             }
     *         },
     *         {
     *             path: {
     *                 tag_id: tagId2
     *             }
     *         }
     *     ]
     * });
     * getTagLinksTagsTagIdLinksGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getTagLinksTagsTagIdLinksGetCombinedResults = qraft.tagsService.getTagLinksTagsTagIdLinksGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 tag_id: tagId1
     *             }
     *         },
     *         {
     *             path: {
     *                 tag_id: tagId2
     *             }
     *         }
     *     ]
     * });
     * getTagLinksTagsTagIdLinksGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetTagLinksTagsTagIdLinksGetSchema,
          GetTagLinksTagsTagIdLinksGetParameters,
          GetTagLinksTagsTagIdLinksGetData,
          GetTagLinksTagsTagIdLinksGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetTagLinksTagsTagIdLinksGetData, GetTagLinksTagsTagIdLinksGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<GetTagLinksTagsTagIdLinksGetData, GetTagLinksTagsTagIdLinksGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Tag Links
     * @description Get all links for a specific tag.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.tagsService.getTagLinksTagsTagIdLinksGet.useSuspenseQuery({
     *     path: {
     *         tag_id: tagId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetTagLinksTagsTagIdLinksGetData>(
      parameters:
        | ServiceOperationQueryKey<GetTagLinksTagsTagIdLinksGetSchema, GetTagLinksTagsTagIdLinksGetParameters>
        | DeepReadonly<GetTagLinksTagsTagIdLinksGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetTagLinksTagsTagIdLinksGetData,
          GetTagLinksTagsTagIdLinksGetError,
          TData,
          ServiceOperationQueryKey<GetTagLinksTagsTagIdLinksGetSchema, GetTagLinksTagsTagIdLinksGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetTagLinksTagsTagIdLinksGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Tag Links
     * @description Get all links for a specific tag.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.tagsService.getTagLinksTagsTagIdLinksGet.useSuspenseInfiniteQuery({
     *     path: {
     *         tag_id: tagId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetTagLinksTagsTagIdLinksGetParameters,
      TData = GetTagLinksTagsTagIdLinksGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetTagLinksTagsTagIdLinksGetSchema, GetTagLinksTagsTagIdLinksGetParameters>
        | DeepReadonly<GetTagLinksTagsTagIdLinksGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetTagLinksTagsTagIdLinksGetData,
          GetTagLinksTagsTagIdLinksGetError,
          OperationInfiniteData<TData, GetTagLinksTagsTagIdLinksGetParameters>,
          ServiceOperationInfiniteQueryKey<GetTagLinksTagsTagIdLinksGetSchema, GetTagLinksTagsTagIdLinksGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetTagLinksTagsTagIdLinksGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetTagLinksTagsTagIdLinksGetParameters>,
      OperationError<GetTagLinksTagsTagIdLinksGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Tag Links
     * @description Get all links for a specific tag.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getTagLinksTagsTagIdLinksGetData = qraft.tagsService.getTagLinksTagsTagIdLinksGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 tag_id: tagId1
     *             }
     *         },
     *         {
     *             path: {
     *                 tag_id: tagId2
     *             }
     *         }
     *     ]
     * });
     * getTagLinksTagsTagIdLinksGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getTagLinksTagsTagIdLinksGetCombinedData = qraft.tagsService.getTagLinksTagsTagIdLinksGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 tag_id: tagId1
     *             }
     *         },
     *         {
     *             path: {
     *                 tag_id: tagId2
     *             }
     *         }
     *     ]
     * });
     * getTagLinksTagsTagIdLinksGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetTagLinksTagsTagIdLinksGetSchema,
          GetTagLinksTagsTagIdLinksGetParameters,
          GetTagLinksTagsTagIdLinksGetData,
          GetTagLinksTagsTagIdLinksGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<GetTagLinksTagsTagIdLinksGetData, GetTagLinksTagsTagIdLinksGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<GetTagLinksTagsTagIdLinksGetData, GetTagLinksTagsTagIdLinksGetError>,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get Tag Links
     * @description Get all links for a specific tag.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetTagLinksTagsTagIdLinksGetSchema,
        GetTagLinksTagsTagIdLinksGetData,
        GetTagLinksTagsTagIdLinksGetParameters,
        GetTagLinksTagsTagIdLinksGetError
      >
    ): Promise<GetTagLinksTagsTagIdLinksGetData>;
    /**
     * @summary Get Tag Links
     * @description Get all links for a specific tag.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetTagLinksTagsTagIdLinksGetSchema,
        GetTagLinksTagsTagIdLinksGetData,
        GetTagLinksTagsTagIdLinksGetParameters,
        GetTagLinksTagsTagIdLinksGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Tag Links
     * @description Get all links for a specific tag.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetTagLinksTagsTagIdLinksGetSchema,
        GetTagLinksTagsTagIdLinksGetData,
        GetTagLinksTagsTagIdLinksGetParameters,
        GetTagLinksTagsTagIdLinksGetError
      >
    ): Promise<GetTagLinksTagsTagIdLinksGetData>;
    /**
     * @summary Get Tag Links
     * @description Get all links for a specific tag.
     */
    fetchInfiniteQuery<TPageParam extends GetTagLinksTagsTagIdLinksGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetTagLinksTagsTagIdLinksGetSchema,
        GetTagLinksTagsTagIdLinksGetData,
        GetTagLinksTagsTagIdLinksGetParameters,
        DeepReadonly<TPageParam>,
        GetTagLinksTagsTagIdLinksGetError
      >
    ): Promise<OperationInfiniteData<GetTagLinksTagsTagIdLinksGetData, GetTagLinksTagsTagIdLinksGetParameters>>;
    /**
     * @summary Get Tag Links
     * @description Get all links for a specific tag.
     */
    prefetchInfiniteQuery<TPageParam extends GetTagLinksTagsTagIdLinksGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetTagLinksTagsTagIdLinksGetSchema,
        GetTagLinksTagsTagIdLinksGetData,
        GetTagLinksTagsTagIdLinksGetParameters,
        DeepReadonly<TPageParam>,
        GetTagLinksTagsTagIdLinksGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Tag Links
     * @description Get all links for a specific tag.
     */
    ensureInfiniteQueryData<TPageParam extends GetTagLinksTagsTagIdLinksGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetTagLinksTagsTagIdLinksGetSchema,
        GetTagLinksTagsTagIdLinksGetData,
        GetTagLinksTagsTagIdLinksGetParameters,
        DeepReadonly<TPageParam>,
        GetTagLinksTagsTagIdLinksGetError
      >
    ): Promise<OperationInfiniteData<GetTagLinksTagsTagIdLinksGetData, GetTagLinksTagsTagIdLinksGetParameters>>;
    /**
     * @summary Get Tag Links
     * @description Get all links for a specific tag.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetTagLinksTagsTagIdLinksGetSchema, GetTagLinksTagsTagIdLinksGetParameters>
        | DeepReadonly<GetTagLinksTagsTagIdLinksGetParameters>
    ): GetTagLinksTagsTagIdLinksGetData | undefined;
    /**
     * @summary Get Tag Links
     * @description Get all links for a specific tag.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetTagLinksTagsTagIdLinksGetSchema, GetTagLinksTagsTagIdLinksGetParameters>
        | DeepReadonly<GetTagLinksTagsTagIdLinksGetParameters>
    ): OperationInfiniteData<GetTagLinksTagsTagIdLinksGetData, GetTagLinksTagsTagIdLinksGetParameters> | undefined;
    /**
     * @summary Get Tag Links
     * @description Get all links for a specific tag.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTagLinksTagsTagIdLinksGetSchema,
            GetTagLinksTagsTagIdLinksGetData,
            TInfinite,
            GetTagLinksTagsTagIdLinksGetParameters,
            GetTagLinksTagsTagIdLinksGetError
          >
        | QueryFiltersByQueryKey<
            GetTagLinksTagsTagIdLinksGetSchema,
            GetTagLinksTagsTagIdLinksGetData,
            TInfinite,
            GetTagLinksTagsTagIdLinksGetParameters,
            GetTagLinksTagsTagIdLinksGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetTagLinksTagsTagIdLinksGetSchema,
              GetTagLinksTagsTagIdLinksGetParameters
            >,
            data:
              | NoInfer<OperationInfiniteData<GetTagLinksTagsTagIdLinksGetData, GetTagLinksTagsTagIdLinksGetParameters>>
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetTagLinksTagsTagIdLinksGetSchema,
              GetTagLinksTagsTagIdLinksGetParameters
            >,
            data: GetTagLinksTagsTagIdLinksGetData | undefined,
          ]
        >;
    /**
     * @summary Get Tag Links
     * @description Get all links for a specific tag.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetTagLinksTagsTagIdLinksGetSchema, GetTagLinksTagsTagIdLinksGetParameters>
        | DeepReadonly<GetTagLinksTagsTagIdLinksGetParameters>
    ): QueryState<GetTagLinksTagsTagIdLinksGetData, GetTagLinksTagsTagIdLinksGetError> | undefined;
    /**
     * @summary Get Tag Links
     * @description Get all links for a specific tag.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetTagLinksTagsTagIdLinksGetParameters>
        | ServiceOperationInfiniteQueryKey<GetTagLinksTagsTagIdLinksGetSchema, GetTagLinksTagsTagIdLinksGetParameters>
    ):
      | QueryState<
          OperationInfiniteData<GetTagLinksTagsTagIdLinksGetData, GetTagLinksTagsTagIdLinksGetParameters>,
          GetTagLinksTagsTagIdLinksGetError
        >
      | undefined;
    /**
     * @summary Get Tag Links
     * @description Get all links for a specific tag.
     */
    setQueryData(
      parameters:
        | DeepReadonly<GetTagLinksTagsTagIdLinksGetParameters>
        | ServiceOperationQueryKey<GetTagLinksTagsTagIdLinksGetSchema, GetTagLinksTagsTagIdLinksGetParameters>,
      updater: Updater<
        NoInfer<GetTagLinksTagsTagIdLinksGetData> | undefined,
        NoInfer<DeepReadonly<GetTagLinksTagsTagIdLinksGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetTagLinksTagsTagIdLinksGetData | undefined;
    /**
     * @summary Get Tag Links
     * @description Get all links for a specific tag.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetTagLinksTagsTagIdLinksGetParameters>
        | ServiceOperationInfiniteQueryKey<GetTagLinksTagsTagIdLinksGetSchema, GetTagLinksTagsTagIdLinksGetParameters>,
      updater: Updater<
        | NoInfer<OperationInfiniteData<GetTagLinksTagsTagIdLinksGetData, GetTagLinksTagsTagIdLinksGetParameters>>
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<GetTagLinksTagsTagIdLinksGetData, GetTagLinksTagsTagIdLinksGetParameters>
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetTagLinksTagsTagIdLinksGetData, GetTagLinksTagsTagIdLinksGetParameters> | undefined;
    /**
     * @summary Get Tag Links
     * @description Get all links for a specific tag.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetTagLinksTagsTagIdLinksGetSchema,
            GetTagLinksTagsTagIdLinksGetData,
            TInfinite,
            GetTagLinksTagsTagIdLinksGetParameters,
            GetTagLinksTagsTagIdLinksGetError
          >
        | QueryFiltersByQueryKey<
            GetTagLinksTagsTagIdLinksGetSchema,
            GetTagLinksTagsTagIdLinksGetData,
            TInfinite,
            GetTagLinksTagsTagIdLinksGetParameters,
            GetTagLinksTagsTagIdLinksGetError
          >,
      updater: Updater<
        NoInfer<GetTagLinksTagsTagIdLinksGetData> | undefined,
        NoInfer<GetTagLinksTagsTagIdLinksGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetTagLinksTagsTagIdLinksGetData | undefined>;
    /**
     * @summary Get Tag Links
     * @description Get all links for a specific tag.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetTagLinksTagsTagIdLinksGetSchema,
        GetTagLinksTagsTagIdLinksGetData,
        TInfinite,
        GetTagLinksTagsTagIdLinksGetParameters,
        GetTagLinksTagsTagIdLinksGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get Tag Links
     * @description Get all links for a specific tag.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTagLinksTagsTagIdLinksGetSchema,
            GetTagLinksTagsTagIdLinksGetData,
            TInfinite,
            GetTagLinksTagsTagIdLinksGetParameters,
            GetTagLinksTagsTagIdLinksGetError
          >
        | QueryFiltersByQueryKey<
            GetTagLinksTagsTagIdLinksGetSchema,
            GetTagLinksTagsTagIdLinksGetData,
            TInfinite,
            GetTagLinksTagsTagIdLinksGetParameters,
            GetTagLinksTagsTagIdLinksGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get Tag Links
     * @description Get all links for a specific tag.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTagLinksTagsTagIdLinksGetSchema,
            GetTagLinksTagsTagIdLinksGetData,
            TInfinite,
            GetTagLinksTagsTagIdLinksGetParameters,
            GetTagLinksTagsTagIdLinksGetError
          >
        | QueryFiltersByQueryKey<
            GetTagLinksTagsTagIdLinksGetSchema,
            GetTagLinksTagsTagIdLinksGetData,
            TInfinite,
            GetTagLinksTagsTagIdLinksGetParameters,
            GetTagLinksTagsTagIdLinksGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get Tag Links
     * @description Get all links for a specific tag.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTagLinksTagsTagIdLinksGetSchema,
            GetTagLinksTagsTagIdLinksGetData,
            TInfinite,
            GetTagLinksTagsTagIdLinksGetParameters,
            GetTagLinksTagsTagIdLinksGetError
          >
        | QueryFiltersByQueryKey<
            GetTagLinksTagsTagIdLinksGetSchema,
            GetTagLinksTagsTagIdLinksGetData,
            TInfinite,
            GetTagLinksTagsTagIdLinksGetParameters,
            GetTagLinksTagsTagIdLinksGetError
          >
    ): void;
    /**
     * @summary Get Tag Links
     * @description Get all links for a specific tag.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTagLinksTagsTagIdLinksGetSchema,
            GetTagLinksTagsTagIdLinksGetData,
            TInfinite,
            GetTagLinksTagsTagIdLinksGetParameters,
            GetTagLinksTagsTagIdLinksGetError
          >
        | QueryFiltersByQueryKey<
            GetTagLinksTagsTagIdLinksGetSchema,
            GetTagLinksTagsTagIdLinksGetData,
            TInfinite,
            GetTagLinksTagsTagIdLinksGetParameters,
            GetTagLinksTagsTagIdLinksGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get Tag Links
     * @description Get all links for a specific tag.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTagLinksTagsTagIdLinksGetSchema,
            GetTagLinksTagsTagIdLinksGetData,
            TInfinite,
            GetTagLinksTagsTagIdLinksGetParameters,
            GetTagLinksTagsTagIdLinksGetError
          >
        | QueryFiltersByQueryKey<
            GetTagLinksTagsTagIdLinksGetSchema,
            GetTagLinksTagsTagIdLinksGetData,
            TInfinite,
            GetTagLinksTagsTagIdLinksGetParameters,
            GetTagLinksTagsTagIdLinksGetError
          >
    ): number;
    schema: GetTagLinksTagsTagIdLinksGetSchema;
    types: {
      parameters: GetTagLinksTagsTagIdLinksGetParameters;
      data: GetTagLinksTagsTagIdLinksGetData;
      error: GetTagLinksTagsTagIdLinksGetError;
    };
  };
}
/**
 * @summary Get All
 * @description Get all tags for the office.
 */
export const getAllTagsGet = {
  schema: {
    method: 'get',
    url: '/tags',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetAllTagsGetSchema;
  [QraftServiceOperationsToken]: TagsService['getAllTagsGet'];
};
/**
 * @summary Create
 * @description Create a new tag.
 */
export const createTagsPost = {
  schema: {
    method: 'post',
    url: '/tags',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateTagsPostSchema;
  [QraftServiceOperationsToken]: TagsService['createTagsPost'];
};
/**
 * @summary Get One
 * @description Get a specific tag by ID.
 */
export const getOneTagsTagIdGet = {
  schema: {
    method: 'get',
    url: '/tags/{tag_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetOneTagsTagIdGetSchema;
  [QraftServiceOperationsToken]: TagsService['getOneTagsTagIdGet'];
};
/**
 * @summary Update
 * @description Update an existing tag.
 */
export const updateTagsTagIdPatch = {
  schema: {
    method: 'patch',
    url: '/tags/{tag_id}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateTagsTagIdPatchSchema;
  [QraftServiceOperationsToken]: TagsService['updateTagsTagIdPatch'];
};
/**
 * @summary Get Tag Links
 * @description Get all links for a specific tag.
 */
export const getTagLinksTagsTagIdLinksGet = {
  schema: {
    method: 'get',
    url: '/tags/{tag_id}/links',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetTagLinksTagsTagIdLinksGetSchema;
  [QraftServiceOperationsToken]: TagsService['getTagLinksTagsTagIdLinksGet'];
};
export const tagsService = {
  getAllTagsGet,
  createTagsPost,
  getOneTagsTagIdGet,
  updateTagsTagIdPatch,
  getTagLinksTagsTagIdLinksGet,
} as const;
type GetAllTagsGetSchema = {
  method: 'get';
  url: '/tags';
  security: ['HTTPBearer'];
};
type GetAllTagsGetParameters = undefined;
type GetAllTagsGetData = paths['/tags']['get']['responses']['200']['content']['application/json'];
type GetAllTagsGetError = unknown;
type CreateTagsPostSchema = {
  method: 'post';
  url: '/tags';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateTagsPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateTagsPostData = paths['/tags']['post']['responses']['201']['content']['application/json'];
type CreateTagsPostError = paths['/tags']['post']['responses']['422']['content']['application/json'];
type CreateTagsPostBody = paths['/tags']['post']['requestBody']['content']['application/json'];
type GetOneTagsTagIdGetSchema = {
  method: 'get';
  url: '/tags/{tag_id}';
  security: ['HTTPBearer'];
};
type GetOneTagsTagIdGetParameters = paths['/tags/{tag_id}']['get']['parameters'];
type GetOneTagsTagIdGetData = paths['/tags/{tag_id}']['get']['responses']['200']['content']['application/json'];
type GetOneTagsTagIdGetError = paths['/tags/{tag_id}']['get']['responses']['422']['content']['application/json'];
type UpdateTagsTagIdPatchSchema = {
  method: 'patch';
  url: '/tags/{tag_id}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateTagsTagIdPatchParameters = paths['/tags/{tag_id}']['patch']['parameters'];
type UpdateTagsTagIdPatchData = paths['/tags/{tag_id}']['patch']['responses']['200']['content']['application/json'];
type UpdateTagsTagIdPatchError = paths['/tags/{tag_id}']['patch']['responses']['422']['content']['application/json'];
type UpdateTagsTagIdPatchBody = paths['/tags/{tag_id}']['patch']['requestBody']['content']['application/json'];
type GetTagLinksTagsTagIdLinksGetSchema = {
  method: 'get';
  url: '/tags/{tag_id}/links';
  security: ['HTTPBearer'];
};
type GetTagLinksTagsTagIdLinksGetParameters = paths['/tags/{tag_id}/links']['get']['parameters'];
type GetTagLinksTagsTagIdLinksGetData =
  paths['/tags/{tag_id}/links']['get']['responses']['200']['content']['application/json'];
type GetTagLinksTagsTagIdLinksGetError =
  paths['/tags/{tag_id}/links']['get']['responses']['422']['content']['application/json'];
